import {
    Container,
    Typography,
    Box,
    Stack,
    Grid,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import MemberFaceForm from "../../components/app/member/MemberFaceForm";

export default function TestMemberFaceForm() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Simple</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                <Grid container rowSpacing={3} columnSpacing={1} sx={{ mt: 1 }}>
                    <Grid item xs={3}>
                    <MemberFaceForm memberID={5} faceId="enrolled"/>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="h4" sx={{ mt: 1 }}>
                            Dummy
                        </Typography>
                    </Grid>

                </Grid>

            </Stack>
        </Container>
    )
}
